import { defineMessages } from 'react-intl';

export const scope = 'app.components.SharedPlayerProfileFields';

export default defineMessages({
  lblFirstName: {
    id: `${scope}.lblFirstName`,
    defaultMessage: 'First Name',
  },
  lblLastName: {
    id: `${scope}.lblLastName`,
    defaultMessage: 'Last Name',
  },
  lblNickname: {
    id: `${scope}.lblNickname`,
    defaultMessage: 'Nickname',
  },
  lblDate: {
    id: `${scope}.lblDate`,
    defaultMessage: 'Date of Birth',
  },
  lblHandedness: {
    id: `${scope}.lblHandedness`,
    defaultMessage: 'Shoots',
  },
});
